import React, { useState, useEffect } from "react";
import * as ConfigTypes from 'config/ConfigTypes';
import { subAfter } from 'helpers/TypeHelper';
import { getProfileData, getScreenHeading }
    from 'helpers/ProfileHelper';
import { showElement, showActions, showCollapse } from 'components/Screen/Screen';
import { handleActionsBottomBtn }
    from 'helpers/ProfileHelper';
import { checkDependForDD } from 'helpers/MetadataHelper';
import "./Profile.scss";

const Profile = ({ formatMessage, screenMode, errors, onBtnClick, onActionClick,
    configObjects, profileObjects, updateProfileObjects, authObjects, loading, msg, subScreen }) => {
    const [userInputs, setUserInputs] = useState(profileObjects[`${screenMode}`] || {});
    const [data, setData] = useState([]);
    const [boxState, setBoxState] = useState(false);
    const [boxData, setBoxData] = useState([]);
    const [isActive, setIsActive] = useState('');
    const formHeading = getScreenHeading({ screenMode, formatMessage });
    let actions = handleActionsBottomBtn({ screenMode });

    const initUserData = ({ screenData }) => {
        const { user } = authObjects;
        let userData = {};
        if (screenData && screenData.length) {
            screenData.forEach(item => {
                if (item.children && item.children.length) {
                    item.children.forEach(child => {
                        if (user && user.metadata && user.metadata.fields
                            && user.metadata.fields[child.field]) {
                            userData[child.field] = user.metadata.fields[child.field]
                        }
                    })
                } else {
                    if (user && user.metadata && user.metadata.fields
                        && user.metadata.fields[item.field]) {
                        userData[item.field] = user.metadata.fields[item.field]
                    }
                    if (item.field.startsWith(ConfigTypes.ONLY_REPEAT)) {
                        let compareFi = subAfter(item.field, ConfigTypes.ONLY_REPEAT);
                        if (user && user.metadata && user.metadata.fields
                            && user.metadata.fields[compareFi]) {
                            userData[item.field] = user.metadata.fields[compareFi];
                        }
                    }
                }
            })
        }
        return userData;
    }

    useEffect(() => {
        let screenData = getProfileData({ screenMode, configObjects, profileObjects });
        setData(screenData);
        let userData = initUserData({ screenData });
        setUserInputs({ ...userData });
    }, [screenMode]);

    useEffect(() => {
        if (subScreen) {
            let screenData = getProfileData({ screenMode: subScreen, configObjects, profileObjects });
            let userData = initUserData({ screenData });
            setUserInputs((prev) => {
                return ({ ...prev, ...userData });
            });
        }
    }, [subScreen]);

    const onCheckBox = (el) => (e) => {
        setUserInputs((prev) => {
            return ({ ...prev, [`${el.name}`]: e.target.checked ? true : false });
        });
    }

    const onInput = (e, name) => {
        setUserInputs((prev) => {
            return ({ ...prev, [name]: e.target.value });
        });
    }

    const onDDCk = (el) => (ddItem) => {
        let isDepend = checkDependForDD({
            profileObjects, entry: el, screenMode,
            ddItem, updateProfileObjects, setUserInputs
        });
        if (!isDepend && profileObjects && profileObjects[el.originalname]
            && profileObjects[el.originalname][ddItem.name]) {
            setUserInputs((prev) => {
                return ({ ...prev, ...profileObjects[el.originalname][ddItem.name], [`${el.name}`]: ddItem });
            });
            updateProfileObjects({
                [`${screenMode}`]: {
                    ...profileObjects[[`${screenMode}`]], [el.name]: ddItem,
                    ...profileObjects[el.originalname][ddItem.name]
                }
            });
        } else {
            setUserInputs((prev) => {
                return ({ ...prev, [`${el.name}`]: ddItem });
            });
        }
    }

    const onBtn = (screenMode) => () => {
        if (screenMode.includes("profile_inst_different_")
            || screenMode.includes("profile_user_different_")) {
            let buff = getProfileData({ screenMode, configObjects, profileObjects });
            if (!boxState) setIsActive(screenMode);
            else setIsActive('');
            setBoxState(!boxState);
            setBoxData(buff);
            onBtnClick({ screenMode });
        } else {
            onBtnClick({ screenMode });
        }
    }

    const showContent = (dataArr) => {
        let fm = formatMessage;
        let dataObjects = profileObjects;
        if (dataArr && dataArr.length > 0) {
            return dataArr.map((item, idx) => {
                let eObj = { el: item, idx, fm, onDDCk, onInput, onCheckBox, onBtn, userInputs, dataObjects, errors };
                let coObj = { el: item, idx, showContent, boxData, formatMessage, isActive, onBtn, boxState };
                if (item.type && item.type === ConfigTypes.COLLAPSE) return showCollapse(coObj);
                if (item.type && (item.type === ConfigTypes.TEXT_FROM_CHILDREN || item.type === ConfigTypes.SPLIT)
                    && item.children && item.children.length > 0) {
                    return showElement(eObj);
                }
                if (item.children && item.children.length > 0) {
                    return (
                        <div className="profile-row" key={`profile-content-${item.name}`}>
                            {item.children.map((el, index) => showElement({ ...eObj, el: el, idx: index, isChild: true }))}
                        </div>
                    )
                }
                return showElement(eObj);
            })
        }
    }

    return (
        <div className="Profile Screen">
            <div className="profile-heading">
                <div className="profile-buff" />
                {formHeading && formHeading}
            </div>
            <>
                {showContent(data)}
                {showActions({ actions, onActionClick, userInputs, formatMessage, loading, msg })}
            </>
        </div>
    )
}

export default Profile;